<template>
    <div class="content">
        <!-- <AisDetail ref="aisDetailRef"></AisDetail> -->
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import {
    SceneItemCommon,
    SceneRichPointItem,
    Pixmap
} from '../../../public/hd/chartbox';

import { llPointToENPoint, llPointsToENPoints, enPointToLLPoint } from '@/utils';
export default {
    inject: ['instanceProvide', 'app'],
    data() {
        return {

            weaStationInterval: null,

        }
    },
    computed: {
        hasLogin(){
            return this.$store.state.hasLogin
        },
        showWeaStation(){
            return this.$store.state.showWeaStation
        }
    },
    watch: {
        hasLogin(newVal, oldVal){
            if(newVal){
                
            }else{
                // 退出登录之后 关闭获取期限信息
                this.closeWeaStation()
            }
        },
        showWeaStation(newVal, oldVal){
            if(newVal){
                console.log('显示气象站')
                this.openWeaStation()
            }else{
                console.log('关闭气象站》》》')
                this.closeWeaStation()
            }
        }
    },
    methods: {
        ...mapMutations(['addweatherPopupItem']),

        /**
         * 检查并删除定时器
         */
        checkRemoveInterval(){
            if(this.weaStationInterval){
                clearInterval(this.weaStationInterval)
            }
        },

        openWeaStation(){
            this.checkRemoveInterval()
            this.weaStationInterval = setInterval(()=>{
                this.queryDataList()
            }, 5000)
            this.queryDataList() // 执行一次
        },

        closeWeaStation(){
            this.checkRemoveInterval()
            if(this.instanceProvide.weaStationLayer){ 
                this.instanceProvide.weaStationLayer.clearItems()
            }
            // this.$refs.aisDetailRef.close()
        },

        queryDataList(){
            this.sswgGet('/weather/getWeaStationList', {}, true, 'json').then(res => {
                console.log(res)
                if(res && res.code==200 && this.showWeaStation){
                    this.draw(res.data) // 返回格式["{\"p1\":0,\"p2\":0,\"p13\":13,\"p16\":0,\"p15\":0,\"sn\":\"81C224FD0004\",\"lat\":22.486502,\"ts\":1742373100}",]
                }
            })
        },

        draw(data){
            // 先清除
            if(this.instanceProvide.weaStationLayer){
                this.instanceProvide.weaStationLayer.clearItems()
            }
            // 循环画物标
            let station = {}
            for(let i=0; i<data.length; i++){
                station = JSON.parse(data[i])
                this.addItem(station)
            }
            // 更新
            this.instanceProvide.weaStationLayer.update()
        },

        addItem(station){
            const point = new SceneRichPointItem({
                center: llPointToENPoint(station.lon, station.lat),
                pixmap: new Pixmap({ src: require('@/assets/img/weather/wea/3.png') }),
                minScale: 6
            })

            // point.setVisible(true)
            // point.setState(SceneItemCommon.ItemState.normal)
            point.data = station
            point.on("hoverenter", (item) => {
                console.log(item)
                this.addweatherPopupItem(item)
            })
            point.on("hoverleave", () => {
                this.addweatherPopupItem(null)
            })

            this.instanceProvide.weaStationLayer.addItem(point)
        }
    }
}
</script>